import React, { useState, useEffect } from 'react'
import { API_URL, customStyles, formatDate, secret_key } from '../components/Constants';

import Swal from "sweetalert2";
import Select from 'react-select';
import axios from 'axios';

import Modal from 'react-modal';
import { useNavigate, Link } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import loading1 from "../assets/loading.gif"

function CompanyStatistics() {
    const [searchTerm, setSearchTerm] = useState('');
    const [companies, setCompany] = useState([]);
    const [cities, setCitygroups] = useState("");
    const [loading, setLoading] = useState(true); 

    const [editcompanies, seteditCompany] = useState({
      city_id: "",
      name: "",
      sender_id: "",
      rate: "",
      onfon_sender_id: "",
      sms_provider: "",
      vas_email: "",
      api_key: ""
    });

    const [companydata, setnewCompanyData] = useState({
      city_id: "",
      name: "",
      sender_id: "",
      rate: "",
      onfon_sender_id: "",
      sms_provider: "",
      vas_email: "",
      api_key: ""
    });

    const [companytoedit, setcompanytoedit] = useState('');
    let navigate = useNavigate()
 
    const handleChange = (e) =>{
      const newdata = { ...companydata }
      newdata[e.target.id] = e.target.value
      setnewCompanyData(newdata)
  } 

  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;

    const fetchCompanies = () => {
      setLoading(true);
      let getCompaniesConfig = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_URL}/get_companies`,
        headers: { 
          'Authorization': token
        }
      };

      axios
      .request(getCompaniesConfig)
      .then((response) => {
        setCompany(response.data)
        setLoading(false);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          navigate(0);
        }
        setLoading(false);
      });
    };
  
    useEffect(() => {
      fetchCompanies();
    }, []);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
      };

    const filteredCompanies = companies.filter((company) => {
    const { id, name, rate, sms_provider } = company;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
        id.toString().toLowerCase().includes(lowerCaseSearchTerm) ||
        name.toLowerCase().includes(lowerCaseSearchTerm) ||
        rate.toLowerCase().includes(lowerCaseSearchTerm) ||
        sms_provider.toLowerCase().includes(lowerCaseSearchTerm)
    );
    });

    const [modalIsOpen, setIsOpen] = useState(false);

    const openModal = () => {
      setIsOpen(true);
    }
  
    const closeModal = () => {
      setIsOpen(false);
    }

    const [editmodalIsOpen, setEditIsOpen] = useState(false);

    const openEditModal = (companyid) => {
      setEditIsOpen(true);
      setcompanytoedit(companyid)
     
      const getCompanyByID = () => {
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${API_URL}/get_company/${companyid}`,
          headers: { 
            'Authorization': token
          }
        }
        
        axios.request(config)
        .then((response) => {
          seteditCompany(response.data)
          seteditCompany((prevEditCompany) => ({
            ...prevEditCompany,
            city_id: { 
              value: response.data.city_id, 
              label: response.data.city_id + ". " + response.data.city_name 
            }
          }));          
        })
        .catch((error) => {
          console.log(error?.response)
        });
      };
      
      getCompanyByID();
    }

    const closeEditModal = () => {
      setEditIsOpen(false);
    }

    const fetchCities = () => {
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_URL}/get_cities`,
        headers: { 
          'Authorization': token
        }
      }
      
      axios.request(config)
      .then((response) => {
        const formattedOptions = response.data.map((city) => ({
          value: city.id,
          label: city.id+". "+city.name
        }));
        setCitygroups(formattedOptions);
      })
      .catch((error) => {
        console.log(error?.response)
      });
    };
    useEffect(() => {
      fetchCities();
    }, []);


    const [isSubmitting, setIsSubmitting] = useState(false);

    const registerCompany = (ev) => {
      ev.preventDefault();

      if (isSubmitting) {
        return;
      }
  
      setIsSubmitting(true);

      let newcompany_data = companydata;
      
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${API_URL}/new_company`,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': token
        },
        data : newcompany_data
      };
      
      axios.request(config)
      .then((response) => {
        setTimeout(() => {
        setIsSubmitting(false)
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "New company was created successfully",
        })
        .then(() => {
          navigate(0);
        });
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data,
        })
        setIsSubmitting(false);
      });
    }

    const handleeditChange = (e) => {
      const editdata = { ...editcompanies }
      editdata[e.target.id] = e.target.value
      seteditCompany(editdata)
    }

    const handleCityChange = (selectedOption) => {
      seteditCompany({
        ...editcompanies,
       city_id: { value: selectedOption.value, label: selectedOption.label }
       //city_id: selectedOption.value
      })
    };

    const editCompany = (e) => {
      e.preventDefault()

      if (isSubmitting) {
        return;
      }
  
      setIsSubmitting(true);

      let editdata = {
        ...editcompanies,
        city_id: editcompanies.city_id?.value,
      };
      
      let config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: `${API_URL}/edit_company/${companytoedit}`,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': token
        },
        data : editdata
      };
      
      axios.request(config)
      .then((response) => {
        setIsSubmitting(false)
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Company edited successfully",
        })
        .then(() => {
          navigate(0);
        });
      })
      .catch((error) => {
        setIsSubmitting(false)
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.error,
        })
      });
    }

    const deleteCompany = (companyid) => {
      Swal.fire({
        title: 'Are you sure you want to delete?',
        text: 'This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          if (isSubmitting) {
            return;
          }
      
          setIsSubmitting(true);

          let config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: `${API_URL}/delete_company/${companyid}`,
            headers: { 
              'Authorization': token
            }
          };
          
          axios.request(config)
          .then((response) => {
            setTimeout(() => {
              setIsSubmitting(false)
              Swal.fire({
                title: 'Deleted!',
                text: 'The item has been deleted.',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false
              })
              .then(() => {
                navigate(0);
              });
            }, 1000);
          })
          .catch((error) => {
            setIsSubmitting(false)
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: error?.response?.data?.error,
            })
          });
        }
      });
    }

    const updateUnits = () => {
      if (isSubmitting) {
        return;
      }
  
      setIsSubmitting(true);
      
      let config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: `${API_URL}/updatecompanystats`,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': token
        }
      };
      
      axios.request(config)
      .then((response) => {
        setIsSubmitting(false)
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Units updated",
        })
        .then(() => {
          navigate(0);
        });
      })
      .catch((error) => {
        setIsSubmitting(false)
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.error,
        })
      });
    }

    return (
    
    <div style={{paddingLeft:'10px'}}>
      {isSubmitting && (
        <div className="loadingsubcontainer loading-overlay">
          <img className="loadingsubimg" src={loading1} alt="" />
        </div>
      )}
      <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Companies</h1>
                </div>{/* /.col */}
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Companies stats</li>
                  </ol>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>

      <form className="form-inline justify-content-end searchBar">
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>
      {loading ? (
          <div className="loadingsubcontainer">
            <img className="loadingsubimg" src={loading1} alt="" />
          </div>
        ) : (
      <div className='table-responsive p-0'>
        <table id="example" className="table table-striped">
        <thead>
            <tr>
                <th>Name</th>
                <th>Sender ID</th>
                <th>Rate</th>
                <th>Units Balance</th>
                <th>Sms Provider</th>
                <th>Total Sent Today</th>
                <th>Total Sent Yesterday</th>
                <th>Last Update</th>
            </tr>
        </thead>
        <tbody>
          {filteredCompanies.map((company, name) => (
            <tr key={name}>
              <td className='upercasewords'>{company.name}</td>
              <td>{company.sender_id}</td>
              <td>{company.rate}</td>
              <td>{company.units}</td>
              <td>{company.sms_provider}</td>
              <td>{company.total_sent_today}</td>
              <td>{company.total_sent_yesterday}</td>
              <td>{formatDate(company.updated_at)}</td>
            </tr>
          ))}
        </tbody>
    </table>
        </div>
        )}
        
    </div>
  )
}

export default CompanyStatistics